const set = {
    tab_key: function (value) {
        return sessionStorage.setItem("live_tab_key", value)
    },
    active_page: function (value) {
        return sessionStorage.setItem("active_live_page", value)
    },
    active_page_size: function (value) {
        return sessionStorage.setItem("active_live_page_size", value)
    },
    active_page_filter: function (value) {
        return sessionStorage.setItem("active_live_page_filter", value)
    },
    active_page_sort: function (value) {
        return sessionStorage.setItem("active_live_page_sort", JSON.stringify(value))
    },
    removed_page: function (value) {
        return sessionStorage.setItem("removed_live_page", value)
    },
    removed_page_size: function (value) {
        return sessionStorage.setItem("removed_live_page_size", value)
    },
    removed_page_filter: function (value) {
        return sessionStorage.setItem("removed_live_page_filter", value)
    },
    removed_page_sort: function (value) {
        return sessionStorage.setItem("removed_live_page_sort", JSON.stringify(value))
    }
}

const get = {
    tab_key: function () {
        return sessionStorage.getItem("live_tab_key")
    },
    active_page: function () {
        return sessionStorage.getItem("active_live_page")
    },
    active_page_size: function () {
        return sessionStorage.getItem("active_live_page_size")
    },
    active_page_filter: function () {
        return sessionStorage.getItem("active_live_page_filter")
    },
    active_page_sort: function () {
        return sessionStorage.getItem("active_live_page_sort")
    },
    removed_page: function () {
        return sessionStorage.getItem("removed_live_page")
    },
    removed_page_size: function () {
        return sessionStorage.getItem("removed_live_page_size")
    },
    removed_page_filter: function () {
        return sessionStorage.getItem("removed_live_page_filter")
    },
    removed_page_sort: function () {
        return sessionStorage.getItem("removed_live_page_sort")
    }
}

export {
    get,
    set
};